import { render, staticRenderFns } from "./Riprenota.vue?vue&type=template&id=aefb654c&"
import script from "./Riprenota.vue?vue&type=script&lang=js&"
export * from "./Riprenota.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports